var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0187 17.3203L18.8887 10.0003C18.3187 8.66027 17.4687 7.90027 16.4987 7.85027C15.5387 7.80027 14.6087 8.47027 13.8987 9.75027L11.9987 13.1603C11.5987 13.8803 11.0287 14.3103 10.4087 14.3603C9.77867 14.4203 9.14867 14.0903 8.63867 13.4403L8.41867 13.1603C7.70867 12.2703 6.82867 11.8403 5.92867 11.9303C5.02867 12.0203 4.25867 12.6403 3.74867 13.6503L2.01867 17.1003C1.39867 18.3503 1.45867 19.8003 2.18867 20.9803C2.91867 22.1603 4.18867 22.8703 5.57867 22.8703H18.3387C19.6787 22.8703 20.9287 22.2003 21.6687 21.0803C22.4287 19.9603 22.5487 18.5503 22.0187 17.3203Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96984 8.88109C8.83657 8.88109 10.3498 7.36782 10.3498 5.50109C10.3498 3.63437 8.83657 2.12109 6.96984 2.12109C5.10312 2.12109 3.58984 3.63437 3.58984 5.50109C3.58984 7.36782 5.10312 8.88109 6.96984 8.88109Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a3b249583bfc1213dccecd1ce029c7ba.svg";
export { ForwardRef as ReactComponent };